import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FreeTrialRole } from "@gx1/gx-npm-lib";
import { GartnerFreeTrialModal, StickyHeaderBanner } from "@gx1/gx-ui-common";
import FreeTrialTimerIcon from "./free-trial-timer.icon";
import styles from "./free-trial-header.styles.module.scss";

type FreeTrialHeaderProps = { daysRemaining?: number; freeTrialRole?: FreeTrialRole | "" };

const FreeTrialHeaderComponent = ({ daysRemaining = 0, freeTrialRole = "" }: FreeTrialHeaderProps) => {
  const { t } = useTranslation();
  const [showMoreInfoModal, setShowMoreInfoModal] = useState(false);

  return (
    <>
      {freeTrialRole && (
        <>
          <div className={styles.bannerWrapper} role="banner">
            <StickyHeaderBanner
              variant={"warning"}
              messageStartIcon={<FreeTrialTimerIcon />}
              message={{
                [FreeTrialRole.FREE_TRIAL_RECIPIENT]: `${daysRemaining} ${t("days remaining in your Gartner BuySmart free trial.")}`,
                [FreeTrialRole.FREE_TRIAL_GUEST]: `${t("You are using a free trial version of Gartner BuySmart that has")} ${daysRemaining} ${t("days remaining.")}`
              }[freeTrialRole]}
              CTALabel={t("More Information")}
              onCTAClick={() => setShowMoreInfoModal(true)}
              noBorderRadius={true}
            />
          </div>
          <GartnerFreeTrialModal
            open={showMoreInfoModal}
            onClose={() => setShowMoreInfoModal(false)}
            onCTAClick={() => setShowMoreInfoModal(false)}
            freeTrialDaysRemaining={daysRemaining}
            freeTrialRole={freeTrialRole}
          />
        </>
      )}
    </>
  );
};

export default FreeTrialHeaderComponent;